// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2OQPN","suppliers":"styles_suppliers__3sk4B","content":"styles_content__27ZeM","checkbox":"styles_checkbox__hRuZG"};